export const CAMPAIGN_WRAPPER = 'campaign-wrapper';
export const UPCOMING_CAMPAIGNS_WRAPPER = 'upcoming-campaigns-wrapper';
export const THB_OUTER_WRAPPER = 'thb-wrapper';
export const M1_REBRANDING = 'isM1Rebranding';
export const VOYAGER_BANNER = 'voyagerBanner';
export const trackEvents = {
    closeEventName: 'myLounge_voucher_close',
    showEventName: 'myLounge_voucher_shown',
    redeemEventName: 'myLounge_voucher_cta',
};
